import PropTypes from 'prop-types';
import React from 'react';

export interface IErrorBoundary {
  children: React.ReactNode;
  errorComponent: React.ReactNode;
  hasError?: boolean;
}

const ErrorBoundary: React.FC<IErrorBoundary> = ({ children, errorComponent, hasError = false }) => {
  return <React.Fragment>{hasError ? errorComponent : children}</React.Fragment>;
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  ErrorBoundary.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    errorComponent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    hasError: PropTypes.bool,
  };
}

export default ErrorBoundary;
